import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as spaceLabAssignment from '../../space-lab-assignment'

export const RESOURCE = {
  payload: {
    description: 'The association between Lab Service and Lab.',
    dimension: spaceLabAssignment.RESOURCE.payload,
    level: 0,
    name: 'Space Lab Assignment Entry',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
